import { useState } from 'react';
import { trpc } from '../../lib/trpc';
import { toast } from 'sonner';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
    DialogTrigger,
    DialogClose
} from "@/components/ui/dialog";
import { Field, FieldGroup } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { CustomButton } from '@/components/uiWrappers/button.tsx';
import { IoAddOutline } from "react-icons/io5";


export function NewQuizModal() {
  const [quizNumber, setQuizNumber] = useState('');
  const [quizTitle, setQuizTitle] = useState('');
  const [error, setError] = useState('');
  const utils = trpc.useUtils();

  const addQuizMutation = trpc.admin.quiz.addQuiz.useMutation({
    onSuccess: () => {
      utils.admin.quiz.getQuizzes.invalidate();
      // onClose();
      setQuizNumber('');
      setQuizTitle('');
      setError('');
      toast.success('Module created successfully!');
    },
    onError: (error) => {
      setError(error.message);
      toast.error(`Failed to create module: ${error.message}`);
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const number = parseInt(quizNumber, 10);

    if (isNaN(number) || number <= 0) {
      setError('Please enter a valid positive number');
      return;
    }

    addQuizMutation.mutate({
      number,
      ...(quizTitle.trim() && { title: quizTitle.trim() }),
    });
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <CustomButton
            type="button"
            variant="default"
        >
          <IoAddOutline size={28} data-icon="inline-start" />
          New Module
        </CustomButton>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md" showCloseButton={false}>
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Create New Module</DialogTitle>
          </DialogHeader>

          <FieldGroup>
            <Field>
              <Label htmlFor="quizNumber">Module Number</Label>
              <Input
                id="quizNumber"
                type="number"
                min="1"
                value={quizNumber}
                onChange={(e) => {
                  setQuizNumber(e.target.value);
                  setError('');
                }}
                placeholder="Enter nodule number"
                autoFocus
              />
              {error && (
                <p className="mt-2 text-sm text-red-600">{error}</p>
              )}
            </Field>
            <Field>
              <Label htmlFor="quizTitle">Module Title (optional)</Label>
              <Input
                id="quizTitle"
                type="text"
                value={quizTitle}
                onChange={(e) => setQuizTitle(e.target.value)}
                placeholder="Enter module title"
              />
            </Field>
          </FieldGroup>

          <DialogFooter>
            <DialogClose asChild>
              <CustomButton
                  type="button"
                  variant="outline"
                  onClick={() => {
                    setQuizNumber('');
                    setQuizTitle('');
                    setError('');
                  }}
              >
               Cancel
              </CustomButton>
            </DialogClose>
            <Button
              type="submit"
              disabled={addQuizMutation.isPending}
            >
              {addQuizMutation.isPending ? 'Creating...' : 'Create as Draft'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
